import analyticsLoggerImpl from '@autopass-web/mochi-analytics';

class Analytics {
  init = (key) => {
    analyticsLoggerImpl.init(key);
  };

  getKey() {
    return analyticsLoggerImpl.getKey();
  }

  getUserId() {
    return analyticsLoggerImpl.getUserId();
  }

  setUserId = (id) => {
    analyticsLoggerImpl.setUserId(id);
  };

  log = (name, properties) => analyticsLoggerImpl.log(name, properties);

  // 條碼付款
  barcode_payment_dialog_pageview = ({ type }) => {
    switch (type) {
      case 'no_payment':
        return this.log('條碼頁-未成功讀取條碼-dialog_pageview', {
          原因: '未設定付款方式',
        });
      case 'fetch_fail':
        return this.log('條碼頁-未成功讀取條碼-dialog_pageview', {
          原因: '條碼讀取失敗',
        });
      case 'times_up':
        return this.log('條碼頁-條碼已過期-actiondialog_pageview');
      case 'payment_timeout':
        return this.log('條碼頁-未成功交易結果-dialog_pageview', {
          原因: '交易逾時',
        });
      case 'payment_fail':
        return this.log('條碼頁-未成功交易結果-dialog_pageview', {
          原因: '交易失敗',
        });
      default:
        return;
    }
  };
  barcode_payment_dialog_onClick = ({ type, action }) => {
    switch (type) {
      case 'fetch_fail':
        return this.log('條碼頁-未成功讀取條碼-dialog_點擊', { 動作: '關閉' });
      case 'times_up':
        return this.log('條碼頁-條碼已過期-actiondialog_點擊', {
          動作: action,
        });
      case 'payment_timeout':
      case 'payment_fail':
        return this.log('條碼頁-未成功交易結果-dialog_點擊', { 動作: '關閉' });
      default:
        return;
    }
  };
  barcode_payment_pageview = () => this.log('條碼頁-成功讀取條碼_pageview');
  barcode_payment_receipt_toggle_onClick = (bool) =>
    this.log('條碼頁-發票載具-收合_點擊', {
      動作: bool ? '收起載具' : '展開載具',
    });
  barcode_payment_receipt_onClick = () =>
    this.log('條碼頁-發票載具-更改_點擊', { 動作: '更改' });
  barcode_payment_refresh_onClick = () => this.log('條碼頁-條碼更新按鈕_點擊');
  barcode_payment_success_pageview = () =>
    this.log('條碼頁-付款成功頁_pageview');
  barcode_payment_success_onClick = () =>
    this.log('條碼頁-付款成功頁-完成_點擊');
  barcode_payment_leave = ({ action }) =>
    this.log('條碼頁_離開', { 觸發離開動作: action });
}

export default Analytics;
